import React from 'react';
import {BrowserRouter, Route} from 'react-router-dom';
import SnippetRedirect from "./SnippetRedirect";
import WalletDownloadTestSnippet from '../TestSnippets/WalletDownloadTestSnippet';

type SnippetRouterProps = {

}

export default function SnippetRouter(props: SnippetRouterProps) {

    return (
        <BrowserRouter>
            <Route path='/snippetredirect' component={SnippetRedirect} />
            <Route path='/walletdownloadtest' component={WalletDownloadTestSnippet} />
        </BrowserRouter>
    )
}